module.exports = __webpack_public_path__ + "img/start_book.10984a09.png";